import {
	Assignment,
} from 'models/assignment.model';
import {
	database,
} from 'utils/database';
import {
	useBasisService,
} from 'services';
import {
	getEndOfDay,
} from '../utils/time/time.util';


import {
	toastError,
	toastSuccess,
} from 'utils/toast';
import {
	getErrorMessageFromStatus,
	getOpenGateTimeWindowErrorMessageWithoutTCReference,
} from 'utils/error';
import {
	addDirectionToAssignments,
} from 'utils/transport';
import {
	RequestTransformer,
} from 'utils/http';

const endpoint = 'api/transport';

export const useTripService = () => { // Model

	const {
		data,
		loading: [isLoading, setIsLoading],
		error: [error, setError],
		http,
		baseUrl,
		table,
	} = useBasisService<Assignment[]>(database.assignments);

	const get = (date: Date): Promise<Assignment[]> => {
		const start = date.toJSON();
		const end = getEndOfDay(date).toJSON();
		const transformer = (assignments: Assignment[]) => {
			addDirectionToAssignments(assignments);
			return assignments;
		};

		const fullPath = `${endpoint}?start=${start}&end=${end}`;

		setIsLoading(true);
		return new Promise<Assignment[]>((resolve, reject) => {
			http.get<Assignment[]>(fullPath,{
				baseUrl,
				table,
				transformer: transformer as RequestTransformer,
			},
			() =>
				// The query that we wish to run a delete upon successful request
				table.where('date').between(start, end, true, true)
			)
				.then(list => {
					setIsLoading(false);
					resolve(list || []);
				})
				.catch(error => {
					setIsLoading(false);
					toastError('Kunne ikke hente transport', getErrorMessageFromStatus(error.status));
					reject(error);
				});
		});
	};

	const openGate = (transportId: number, gln: string, supportiveText: string, isArriving = true, onSuccess?: any) => {
		const url = `api/transport/${transportId}/gates/${gln}`;
		setIsLoading(true);

		http.put<void>(url, '', {
			baseUrl,
			discardResponse: true,
		})
			.then(() => {
				setIsLoading(false);
				if (!!onSuccess) {
					onSuccess();
				}
				console.log('Gate has opened?...setting true');
				if (isArriving) {
					toastSuccess('Velkommen inn!', supportiveText, 10000);
				}

				else {
					toastSuccess('Velkommen tilbake!', 'Bommen åpnes ...', 10000);
				}
			})
			.catch(error => {
				setIsLoading(false);
				console.log('Gate has opened?...setting false');
				toastError('Beklager', getOpenGateTimeWindowErrorMessageWithoutTCReference(error), 10000)
			});
	}

	const patchStatus = (transportId: number, status: string) => {

		const url = `api/transport/${transportId}`;

		http.patch<void>(url, {
			status,
		}, {
			baseUrl,
			table,
			tableId: transportId,
		})
			.then(() =>
				toastSuccess('', `${status === 'Loaded' ? 'Henting' : 'Levering'} er registrert!`, 3000)
			)
			.catch(error =>
				toastError('Kunne ikke oppdatere status', getErrorMessageFromStatus(error.status)));
	}

	const patchParkingLot = (transportId: number, parkingLot: string, location = 'destination') => {
		const url = `${endpoint}/${transportId}`;
		http.patch<void>(url, {
			[`route.${location}.address.parkingLot`]: parkingLot,
		}, {
			baseUrl,
			table,
			tableId: transportId,
		})
			.catch(error =>
				toastError('Kunne ikke oppdatere parkeringsplass', getErrorMessageFromStatus(error.status)));
	}

	const update = () => {
		setIsLoading(true);
		http.post<any>(endpoint, {
			title: 'TC test',
			body: 'greetings!',
			userId: 1,
		}, {
			baseUrl,
			table,
			timeout: 0,
		})
			.then(() => setIsLoading(false))
			.catch(error => {
				setIsLoading(false);
				setError(error);
				toastError('Kunne ikke oppdatere transport', getErrorMessageFromStatus(error.status));
			});
	};

	return {
		database,
		data,
		isLoading,
		error,
		get,
		update,
		patchParkingLot,
		patchStatus,
		openGate,
	};
};